const routerOptions = {
    complaintsForm: {
        path: '/reklamationsformular',
        name: 'complaintsform',
        component: () => import(/* webpackChunkName: "product" */ '../components/customer/complaints/ComplaintForm'),
        meta: {
            metaInfoProvider: true,
            resource: '*/order-process',
            priority: 1,
        },
    },
    customerService: {
        path: '/customer-service',
        redirect: { name: 'complaintsform' },
    },
};

export default routerOptions;
